var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"cookie_bar__text"},[_vm._v("This website uses cookies to improve the user experience")]),_vm._v(" "),_c('button',{staticClass:"button--cta",on:{"click":_vm.confirm}},[_vm._v("I understand")]),_vm._v(" "),_c('button',{staticClass:"button--link"},[_vm._v("More information")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5acafa7a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookies/CookieBanner.vue
// module id = 687
// module chunks = 5